import { createSelector } from 'reselect';

import normalizeBlocks from 'core/utils/normalize-blocks';

import { RootState } from 'core/store/types';

import { RoutingState } from '@web-solutions/store/types';

const getFlow = (state: RootState) => state.remoteConfig.flow;

export const selectFlowBlocks = createSelector([getFlow], (flow) => {
  let r = normalizeBlocks(flow);
  return r;
});

export const selectFlow = createSelector([selectFlowBlocks], (flow) => {
  const flatFlow = flow.flat();
  return flatFlow;
});

type RoutingSubset = Pick<RoutingState, 'currentStep' | 'isCompleted' | 'startRoute'>;

export const routingSelectors: {
  [K in keyof RoutingSubset]: (state: { routing: RoutingSubset }) => RoutingSubset[K];
} = {
  currentStep: (state) => state.routing.currentStep,
  isCompleted: (state) => state.routing.isCompleted,
  startRoute: (state) => state.routing.startRoute,
};
